module.exports = __webpack_public_path__ + "static/img/xtt.ea16514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xtt.png
// module id = ZqcS
// module chunks = 1